<div class="popup-backdrop mat-elevation-z8">
    <div class="popup mat-card">
        <button mat-icon-button class="close-button" (click)="close()">✕</button>
        <p class="popup-message" [innerHTML]="message"></p>
        <a *ngIf="linkUrl" [href]="linkUrl" target="_blank" class="popup-link">{{ linkText }}</a>
    </div>
</div>